import { render, staticRenderFns } from "./error-content.vue?vue&type=template&id=644920d7"
import script from "./error-content.vue?vue&type=script&lang=js"
export * from "./error-content.vue?vue&type=script&lang=js"
import style0 from "./error-content.vue?vue&type=style&index=0&id=644920d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports